import {FC, useEffect, useState} from 'react'
import {Content} from '../../../_metronic/layout/components/Content'
import {useAuth} from '../../modules/auth'
import axios from 'axios'

const MiPerfilHeader: FC = () => {
  const API_URL = process.env.REACT_APP_API_URL
  const {currentUser} = useAuth()

  const [stripeSession, setStripeSession] = useState()

  const myProfileHeader = () => {
    axios.get(API_URL + '/app/myProfileHeader/' + currentUser?.id).then((response) => {
      console.log(response.data)

      var firstName = response.data[0].first_name
      var lastName = response.data[0].last_name
      var email = response.data[0].email
      var plan = response.data[0].plan
      var subscription = response.data[0].subscription
      var sessionID = response.data[0].session_id

      setStripeSession(sessionID)
    })
  }

  useEffect(() => {
    myProfileHeader()
  }, [])

  return (
    <>
      <Content>
        <div className='card mb-5 mb-xl-10'>
          <div className='card-body pt-9 pb-0'>
            <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
              <div className='flex-grow-1'>
                <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                  <div className='d-flex flex-column'>
                    <div className='d-flex align-items-center mb-2'>
                      <a href='#' className='text-gray-800 text-hover-primary fs-2 fw-bolder me-1'>
                        {currentUser?.first_name} {currentUser?.last_name}
                      </a>
                      <form
                        action={API_URL + '/stripe/createPortalSession'}
                        method='POST'
                        className='text-center'
                      >
                        <input
                          type='hidden'
                          id='session_id'
                          name='session_id'
                          value={stripeSession}
                        />
                        {(() => {
                          if (currentUser) {
                            if (currentUser.plan != 'Admin') {
                              return (
                                <>
                                  <button
                                    id='checkout-and-portal-button'
                                    type='submit'
                                    className='btn btn-sm btn-light-success fw-bolder ms-2 fs-8 py-1 px-3'
                                  >
                                    Maneja tu suscripción
                                  </button>
                                </>
                              )
                            }
                          }
                        })()}
                      </form>
                    </div>

                    <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                      <a
                        href='#'
                        className='d-flex align-items-center text-gray-500 text-hover-primary mb-2'
                      >
                        {currentUser?.email}
                      </a>
                    </div>

                    <div className="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2">
                      <a
                        href="#"
                        className="d-flex align-items-center text-gray-500 text-hover-primary mb-2"
                      >
                        Tu plan actual: {currentUser?.plan}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Content>
    </>
  )
}

export {MiPerfilHeader}
